<!-- /* ALTERADO PELA PGE-RS:
a) Deixando o login automático: se tem números, é CPF; se não é pela rede.
b) Ajuste de labels.
*/ -->
<h1 mat-dialog-title>Sessão expirada</h1>
@if (!loadingConfig && config && !config.error) {
  <div class="login-form" [@animate]="{value:'*', params:{duration:'300ms',y:'100px'}}"
    >
    @if (false) {
      <div class="logo"><!-- ALTERADO PELA PGE-RS: *ngIf="false" -->
        <img [src]="config.logo">
      </div>
    }
    <div class="title mb-2">{{ config.name }}</div>
    <div class="subtitle mb-2">{{ config.environment }}</div>
    <br />
    <form name="form" [formGroup]="form" novalidate>
      <mat-form-field appearance="outline">
        <mat-label>{{form.get('tipoLogin').value === 'ldap' ? 'Usuário da Rede' : 'CPF'}}</mat-label>
        <input matInput ui-mask="999.999.999-99" formControlName="username" (keyup)="onChangeTipoLogin2()" style="height: 22px;">
        <mat-icon matSuffix class="text-secondary">person</mat-icon>
        @if (form.get('username').hasError('required')) {
          <mat-error>
            {{form.get('tipoLogin').value === 'ldap' ? 'Usuário da Rede' : 'CPF'}} é obrigatório
          </mat-error>
        }
        @if (!form.get('username').hasError('required') &&
          form.get('username').hasError('username')) {
          <mat-error
            >
            Entre com um {{form.get('tipoLogin').value === 'ldap' ? 'Usuário da Rede' : 'CPF'}} válido
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Senha</mat-label>
        <input matInput type="password" formControlName="password" style="height: 22px;">
        <mat-icon matSuffix class="text-secondary">vpn_key</mat-icon>
        <mat-error>
          Senha é obrigatório
        </mat-error>
      </mat-form-field>
      @if (errorMessage) {
        <div class="flex flex-row xs:flex-col self-center">
          <mat-error>
            {{errorMessage}}
          </mat-error>
        </div>
      }
      @if (config.tiposLogin.includes('login_ldap_ativo') || config.tiposLogin.includes('login_interno_ativo')) {
        <button (click)="onSubmit(form.value)" mat-raised-button color="primary" class="submit-button"
          aria-label="login"
          [disabled]="form.invalid">
            Acessar o SUPP
        </button>
      }
      @if (config.tiposLogin.includes('login_govbr_ativo') && config.govBR?.client_id) {
        <a mat-raised-button
           [href]="config.govBR?.sso_url+'/authorize?response_type=code&client_id='+config.govBR?.client_id+'&scope=openid+email+phone+profile+govbr_confiabilidades+govbr_empresa&redirect_uri='+config.govBR?.redirect_uri"
           class="submit-button gov-br" aria-label="entrar com gov.br">
            Entrar com <strong>gov.br</strong>
        </a>
}

        <div class="flex flex-row xs:flex-col self-center">
            @if (loading) {
<mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
}
        </div>
    </form>

    <div class="subtitle mt-3">{{config.version}}</div>
</div>
}
